import { atom } from "jotai";

export interface ICarrier {
    id?: number;
    created_at?: string;
    name: string;
    code: string;
    tracking_url_template: string;
    is_active: boolean;
}

export interface ICarrierInput {
    name: string;
    code: string;
    tracking_url_template: string;
}

export const carriersAtom = atom<ICarrier[]>([]);
export const carriersLoadingAtom = atom<boolean>(false);
